import Vuex from 'vuex';

import session from './modules/session';
import payment from './modules/payment';
import modal from './modules/modal';
import financial from './modules/financial';
import couple from './modules/couple';
import financialGoals from './modules/financialGoals';
import financialAdvisor from './modules/financialAdvisor';

export default new Vuex.Store({

    modules: {
        session,
        payment,
        modal,
        financial,
        couple,
        financialGoals,
        financialAdvisor,
    }

});
